// TODO replace all SupervisorRoleTypes with new utils constant SUPERVISOR_TYPE
export enum SUPERVISOR_TYPE {
  CHIEF_SUPERVISOR = 'CHIEF_SUPERVISOR', // just for Chief Supervisor

  CO_SUPERVISOR = 'CO_SUPERVISOR',
  EXTERNAL_CO_SUPERVISOR = 'EXTERNAL_CO_SUPERVISOR',
  EXTERNAL_CHIEF_JOINT = 'EXTERNAL_CHIEF_JOINT', // Joint External Chief Supervisor
  EXTERNAL_CHIEF_DUAL = 'EXTERNAL_CHIEF_DUAL', // Dual External Chief Supervisor

  // MOD 2024/09/26, keep for compatibility with older data in supervisor team section
  EXTERNAL_CHIEF_SUPERVISOR = 'EXTERNAL_CHIEF_SUPERVISOR',
}
